module.exports = __webpack_public_path__ + "static/media/marsh_master_alt.2d0b155c.svg";